<template>
  <modalGeneric
    title="Add To Collection"
    @closeModal="close"
    :theme="`addRemoveItemsToCollection ${collectionsList.length ? 'addRemoveItemsToCollection--hasItems' : ''}`">
    <ul v-if="collectionsList.length" class="containerAddRemoveItemsToCollectionGeneric" :class="{'hasScrollbar': hasScrollbar}">
      <li v-for="(item, index) in collectionsList" :key="index"
        class="containerAddRemoveItemsToCollectionGeneric__contentAddCollectionsItem"
        :class="[item.containId ? 'containerAddRemoveItemsToCollectionGeneric__contentAddCollectionsItemRemove' : 'containerAddRemoveItemsToCollectionGeneric__contentAddCollectionsItemAdd',
        {'containerAddRemoveItemsToCollectionGeneric__contentAddCollectionsItemRemove': loading && currentIndexCollection === index}]"
        @click="addRemoveItemFromCollection(item.containId, item.id, index)">
        <span class="containerAddRemoveItemsToCollectionGeneric__contentAddCollectionsItem--name">{{item.name}}</span>
        <section class="containerAddRemoveItemsToCollectionGeneric__contentAddCollectionsItem--options">
          <div class="processOptions" v-if="loading && currentIndexCollection === index">
            <spinnerGeneric class="addToCollectionSpinner" />
            <span class="processOptions__workingLabel">WORKING</span>
          </div>
          <span class="addRemoveLabel" v-else>{{setAction(item.containId)}}</span>
          <span class="grey-icon-close icon"></span>
        </section>
      </li>
    </ul>
    <div class="containerEmptyCollection" v-else>
      <img class="containerEmptyCollection__image" src="../../../assets/no-collections.svg" />
      <span class="containerEmptyCollection__phraseOne">
        You don't have collections yet.
      </span>
      <span class="containerEmptyCollection__phraseTwo">Click on the <strong>“New Collection”</strong> button to create them.</span>
    </div>
    <div class="containerCreateCollection">
      <button @click="goToNewCollection" class="containerCreateCollection__button">NEW COLLECTION</button>
    </div>
  </modalGeneric>
</template>

<script>
import { computed, ref } from 'vue'
import spinnerGeneric from '../spinnerGeneric/spinnerGeneric'
import modalGeneric from '../modalGeneric/modalGeneric'
import { iOSVersion, isMobileResolution } from '../../../utils'
import { addRemoveItemsFromCollection } from '../../../services'

export default {
  name: 'addRemoveItemsToCollectionGeneric',
  emits: ['goToNewCollection', 'close', 'updateCollectionContainId'],
  components: {
    spinnerGeneric,
    modalGeneric
  },
  props: {
    cardsId: {
      type: Array,
      required: true
    },
    collectionsList: {
      type: Array,
      required: true
    },
    analyticData: {
      type: Object,
      required: false,
      default: null
    }
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const currentIndexCollection = ref('')

    /**
     * @description Show ADD or REMOVE in collections list depending id attr is true or false
     * @param value containId attr
     */
    const setAction = computed(() => {
      return value => value ? 'REMOVE' : 'ADD'
    })

    /**
     * @description Checks if the modal has scrollbar
     */
    const hasScrollbar = computed(() => {
      return (!isMobileResolution() && props.collectionsList.length > 5) || (isMobileResolution() && props.collectionsList.length * 50 + 128 > window.innerHeight && !(iOSVersion() >= 13))
    })

    /**
     * @description Call service to add or remove item from collection and update array reactivity
     * @param containId attribute from array that indicate if item exist in collection or not.
     * @param collectionId Id collection where user wants to add item.
     * @param index Index of array from collections do actions in unique item. ex: show WORKING when item is being added
     * without affect other items in collections list
     */
    function addRemoveItemFromCollection (containId, collectionId, index) {
      currentIndexCollection.value = index
      if (!containId) loading.value = true
      addRemoveItemsFromCollection(collectionId, containId ? 'remove' : 'add', props.cardsId, props.analyticData).then(() => {
        emit('updateCollectionContainId', index)
        loading.value = false
      })
    }

    /**
     * @description Emits goToNewCollection event
    */
    function goToNewCollection () {
      emit('goToNewCollection')
    }

    /**
     * @description Close modal
     */
    function close () {
      emit('close')
    }

    return {
      loading,
      currentIndexCollection,
      setAction,
      addRemoveItemFromCollection,
      goToNewCollection,
      hasScrollbar,
      close
    }
  }
}
</script>
